import { REHYDRATED } from '../actions';

export default (sliceIdsSelector, dispatchFetchForSlice) => store => next => action => {
  const ret = next(action);
  if (action.type === REHYDRATED) {
    sliceIdsSelector(store.getState())
      .forEach(sliceId => dispatchFetchForSlice(store, sliceId));
  }
  return ret;
};
